module.exports = __webpack_public_path__ + "images/external_images/img/map-markers/map-marker1.png";